<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      title="更新备注"
      id-key="LeaveId"
      :data="data"
      form-label-width="55px"
      :form-rules="rules"
      :save-func="api.updateRemark"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-form-item label="备注" prop="Remark">
            <el-input size="mini" type="textarea" style="width:100%" :autosize="{ minRows: 3 }" v-model="data.Remark" placeholder="请填写备注"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-tag type="primary" v-for="(item,index) in tagList" size="small" class="tag" :key="item" @click="tagClick(item,index)"
            :style="isMB?'margin-bottom: 10px;':(index==0?'margin-bottom: 10px;':'')">
            <span style="vertical-align: 1px;">{{tagNum(index)}}</span>
            {{item}}
          </el-tag>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  computed: {
    tagList() {
      switch (this.data.LeaveType) {
        case "病假":
          return ["感冒（体温≧37.3℃）","感冒（体温<37.3℃）","肠胃不适（拉肚子、呕吐、胃痛等）","外伤：","调整","其他："];
        case "事假":
          return ["家里有事：","艺考、港澳籍等","防疫1在家","防疫2隔离宿舍","防疫3隔离酒店","防疫4在医院","其他："];
        case "走读":
          return ["肠胃调理","调整","其他："];
        case "公假":
          return ["参加竞赛等","学生活动（团委、社团工作）","其他："];
        case "校本课程":
          return ["培优加强","竞赛训练"];
        case "校内其他":
          return ["学生活动（团委、社团工作）","其他："];
        default:
          return [];
      }
    },
  },
  data() {
    return {
      data: {
        StudentIds: [],
        LeaveId: 0,
        SectionId: 0,
        StudentId: 0,
        FullName: "",
        TeacherId: null,
        TermId: null,
        TermNumber: "",
        StartDate: "",
        EndDate: "",
        StartSectionId: null,
        StartSection: "",
        EndSectionId: null,
        EndSection: "",
        LeaveType: "",
        LeaveMode: 0,
        SectionIds: "",
        SectionNames: "",
        Status: "正常",
        ClassId: 0,
        GradeId: 0,
        SectionMode: 0,
        SectionType: 0,
        WeekDays: "",
        Remark: "",
        sIds: [],
        StartSectionEndTime: "",
      },
      WeekDays: ["星期一","星期二","星期三","星期四","星期五","星期六","星期日"],
      api: require("@/api/st/leave").default,
      isMB: this.$store.state.isMB,
      rules: {
        Remark: [{ required: true, message: "备注不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(row) {
      
    },
    onBeforeSave() {
      this.loading(true);
      this.api.updateRemark({
        LeaveId: this.data.LeaveId,
        Remark: this.data.Remark,
      }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.close(true);
          this.$emit("close-saved");
          this.$message.success(res.Msg);
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
    },
    onClosed() {
      
    },
    tagClick(item,index) {
      if(!this.pass) this.data.Remark += this.tagNum(index)+item;
    },
    tagNum(index) {
      switch (index) {
        case 0:
          return "①";
        case 1:
          return "②";
        case 2:
          return "③";
        case 3:
          return "④";
        case 4:
          return "⑤";
        case 5:
          return "⑥";
        case 6:
          return "⑦";
      }
    },
  }
};
</script>
<style lang="scss">
.tag {
  font-size:12px;
  cursor:pointer;
  margin: 0px 10px 0px 0;
}
</style>